export default __webpack_public_path__ + "static/media/DPE_C_WHITE.a9289dd2.png";